var _defs, _g, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    zoomAndPan: "magnify",
    viewBox: "0 0 750 749.999995",
    height: 32,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "c54f5590ef"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 128.746094 226.371094 L 621.289062 226.371094 L 621.289062 650.25 L 128.746094 650.25 Z M 128.746094 226.371094 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c54f5590ef)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 171.070312 226.851562 L 579.039062 226.851562 C 583.871094 226.851562 587.816406 230.671875 588.015625 235.457031 L 621.25 640.542969 L 621.261719 640.542969 C 621.664062 645.488281 617.984375 649.832031 613.039062 650.234375 C 612.789062 650.253906 612.535156 650.265625 612.289062 650.265625 L 137.738281 650.265625 C 132.769531 650.265625 128.746094 646.242188 128.746094 641.273438 C 128.746094 640.898438 128.769531 640.527344 128.8125 640.160156 L 162.046875 235.140625 L 171.003906 235.84375 L 162.042969 235.105469 C 162.429688 230.378906 166.40625 226.8125 171.070312 226.851562 Z M 570.765625 244.828125 L 179.273438 244.828125 L 147.484375 632.289062 L 602.554688 632.289062 L 570.765625 244.828125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 506.265625 303.542969 C 515.953125 303.542969 523.804688 311.398438 523.804688 321.085938 C 523.804688 330.769531 515.953125 338.621094 506.265625 338.621094 C 496.582031 338.621094 488.722656 330.769531 488.722656 321.085938 C 488.722656 311.398438 496.582031 303.542969 506.265625 303.542969 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 243.773438 303.542969 C 253.460938 303.542969 261.308594 311.398438 261.308594 321.085938 C 261.308594 330.769531 253.460938 338.621094 243.773438 338.621094 C 234.085938 338.621094 226.230469 330.769531 226.230469 321.085938 C 226.230469 311.398438 234.085938 303.542969 243.773438 303.542969 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 231.527344 328.167969 C 231.527344 333.136719 235.550781 337.160156 240.519531 337.160156 C 245.480469 337.160156 249.503906 333.136719 249.503906 328.167969 C 249.503906 214.121094 282.425781 141.625 324.570312 110.332031 C 340.148438 98.761719 356.964844 92.976562 373.714844 92.976562 C 390.46875 92.976562 407.285156 98.761719 422.859375 110.332031 C 465.003906 141.625 497.929688 214.117188 497.929688 328.167969 C 497.929688 333.136719 501.953125 337.160156 506.917969 337.160156 C 511.882812 337.160156 515.90625 333.136719 515.90625 328.167969 C 515.90625 207.808594 479.777344 130.277344 433.535156 95.933594 C 414.738281 81.980469 394.265625 75 373.714844 75 C 353.167969 75 332.691406 81.980469 313.898438 95.933594 C 267.65625 130.277344 231.527344 207.808594 231.527344 328.167969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartWhite);
export default __webpack_public_path__ + "static/media/cart_white.76a34b3a441170840c582cba1816c112.svg";
export { ForwardRef as ReactComponent };